import * as React from 'react';
import { observer } from 'mobx-react';

import { dateFormatter, DateFormat, translation, translationForMts } from 'easit--localization';

export interface ISavedTicketProps {
    ticketNumber: string;
    expirationDate: Date;
    onCreateIdenticalTicket: () => void;
    clearCoupon: () => void;
}

export const SavedTicket: React.FC<ISavedTicketProps> = observer((props: ISavedTicketProps) => {
    const t = translationForMts();
    return <div>
        <div className="saved-ticket">
            <div className="header">{t.savedTicket_header}</div>
            <div className="content">
                <p><strong>{t.savedTicket_thanks}</strong></p>
                <p>{t.savedTicket_p1} <strong>{props.ticketNumber}</strong>.</p>
                <p>{t.savedTicket_p2} {dateFormatter.formatDate(props.expirationDate, DateFormat.DDMMYYYY,)}.</p>
                <p className="warning">{t.savedTicket_warning}</p>
            </div>
        </div>
        <div className="pay-buttons w-100">
            <button className="btn btn-secondary" onClick={() => { props.onCreateIdenticalTicket(); }}>
                {translation().coupon_CopyTicket}
            </button>

            <button className="btn btn-primary" onClick={() => { props.clearCoupon() }} >{translation().coupon_NewTicket}</button>
        </div>
    </div >
});